import { withLegacyRouter } from '../../../../../decorators'

import NarusTeamGrid from './narusTeamGrid'

function NarusTeamDemographics ({ params }) {
  return (
    <div className='main'>
      <NarusTeamGrid params={{ id: params.id }} />
    </div>
  )
}

export default withLegacyRouter(NarusTeamDemographics)
